<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
    <div class="container-header-inner-list">

        <div class="row mb-4">
            <div class="col-12">
                <div class="title-wrapper">
                    <div>
                        <h1 class="title-default">Lançamentos Conciliados</h1>
                        <p class="welcome-message">
                            <button mat-icon-button (click)="voltar()" matTooltip="Voltar para lançamentos pendentes">
                                <mat-icon>arrow_back</mat-icon>
                            </button>
                            Lançamentos bancários que já foram conciliados com movimentações do ERP.
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <!-- Filtros + Totalizador (layout dois colunas no desktop) -->
        <div class="filtros-e-total-wrapper mb-3">

            <!-- Coluna de filtros -->
            <div class="filtros-col">

                <!-- Seletor de conta -->
                <div class="mb-3">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Instituição Financeira</mat-label>
                        <mat-select [ngModel]="idContaFinanceira" (ngModelChange)="onContaChange($event)">
                            <mat-option *ngFor="let conta of _contas" [value]="conta.idContaFinanceira">
                                {{ labelConta(conta) }}
                            </mat-option>
                        </mat-select>
                        <mat-hint *ngIf="agencia">Ag. {{ agencia }} · CC {{ numeroConta }}</mat-hint>
                    </mat-form-field>
                </div>

                <!-- Busca + período -->
                <div class="filtros-row search-area" [formGroup]="model">
                    <mat-form-field appearance="outline" class="busca-field" subscriptSizing="dynamic">
                        <mat-label>Buscar descrição</mat-label>
                        <input matInput type="search" [(ngModel)]="pesquisa" [ngModelOptions]="{standalone: true}"
                            (keyup.enter)="carregarConciliados(true)" placeholder="Busque por descrição...">
                        <button mat-icon-button matSuffix (click)="carregarConciliados(true)" type="button">
                            <mat-icon>search</mat-icon>
                        </button>
                    </mat-form-field>

                    <!-- Seletor de período -->
                    <button #periodoMenuTrigger="matMenuTrigger" mat-stroked-button type="button" class="btn-periodo"
                        [matMenuTriggerFor]="periodoMenu" (menuOpened)="prepararPeriodoIntervalo()"
                        [class.btn-periodo--ativo]="periodoSelecionado !== PeriodoConciliadosEnum.DoMes">
                        {{ periodoLabel }}
                        <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
                    </button>
                    <mat-menu #periodoMenu="matMenu" class="periodo-custom-menu" (closed)="onPeriodoMenuClosed()">
                        <div class="periodo-menu-content">
                            <div>
                                <button type="button" class="periodo-menu-item"
                                    (click)="selecionarPeriodo(PeriodoConciliadosEnum.Hoje); aplicarPeriodo()"
                                    [class.periodo-item-selecionado]="periodoSelecionado === PeriodoConciliadosEnum.Hoje">
                                    <span>hoje</span>
                                    @if (periodoSelecionado === PeriodoConciliadosEnum.Hoje) {
                                    <mat-icon>check</mat-icon>
                                    }
                                </button>
                                <button type="button" class="periodo-menu-item"
                                    (click)="selecionarPeriodo(PeriodoConciliadosEnum.DaSemana); aplicarPeriodo()"
                                    [class.periodo-item-selecionado]="periodoSelecionado === PeriodoConciliadosEnum.DaSemana">
                                    <span>desta semana</span>
                                    @if (periodoSelecionado === PeriodoConciliadosEnum.DaSemana) {
                                    <mat-icon>check</mat-icon>
                                    }
                                </button>
                                <button type="button" class="periodo-menu-item"
                                    (click)="selecionarPeriodo(PeriodoConciliadosEnum.DoMes); aplicarPeriodo()"
                                    [class.periodo-item-selecionado]="periodoSelecionado === PeriodoConciliadosEnum.DoMes">
                                    <span>do mês</span>
                                    @if (periodoSelecionado === PeriodoConciliadosEnum.DoMes) {
                                    <mat-icon>check</mat-icon>
                                    }
                                </button>
                                <button type="button" class="periodo-menu-item"
                                    (click)="selecionarPeriodo(PeriodoConciliadosEnum.Ultimos30Dias); aplicarPeriodo()"
                                    [class.periodo-item-selecionado]="periodoSelecionado === PeriodoConciliadosEnum.Ultimos30Dias">
                                    <span>últimos 30 dias</span>
                                    @if (periodoSelecionado === PeriodoConciliadosEnum.Ultimos30Dias) {
                                    <mat-icon>check</mat-icon>
                                    }
                                </button>
                                <button type="button" class="periodo-menu-item"
                                    (click)="selecionarPeriodo(PeriodoConciliadosEnum.DoIntervalo); $event.stopPropagation()"
                                    [class.periodo-item-selecionado]="periodoSelecionado === PeriodoConciliadosEnum.DoIntervalo">
                                    <span>do intervalo</span>
                                    @if (periodoSelecionado === PeriodoConciliadosEnum.DoIntervalo) {
                                    <mat-icon>check</mat-icon>
                                    }
                                </button>

                                @if (periodoSelecionado === PeriodoConciliadosEnum.DoIntervalo) {
                                <div class="periodo-intervalo-fields" (click)="$event.stopPropagation()">
                                    <mat-form-field appearance="outline">
                                        <mat-label>De</mat-label>
                                        <input matInput [matDatepicker]="pickerDe" placeholder="DD/MM/AAAA"
                                            (input)="onDateInput($event)" formControlName="dataDe">
                                        <mat-datepicker-toggle matSuffix [for]="pickerDe"></mat-datepicker-toggle>
                                        <mat-datepicker #pickerDe></mat-datepicker>
                                        @if (model.get('dataDe')?.hasError('required')) {
                                        <mat-error>Data inicial obrigatória</mat-error>
                                        }
                                    </mat-form-field>
                                    <mat-form-field appearance="outline">
                                        <mat-label>Até</mat-label>
                                        <input matInput [matDatepicker]="pickerAte" placeholder="DD/MM/AAAA"
                                            (input)="onDateInput($event)" formControlName="dataAte">
                                        <mat-datepicker-toggle matSuffix [for]="pickerAte"></mat-datepicker-toggle>
                                        <mat-datepicker #pickerAte></mat-datepicker>
                                        @if (model.get('dataAte')?.hasError('required')) {
                                        <mat-error>Data final obrigatória</mat-error>
                                        }
                                        @if (model.get('dataAte')?.hasError('dataInvalida')) {
                                        <mat-error>Data final menor que inicial</mat-error>
                                        }
                                        @if (model.get('dataAte')?.hasError('intervaloExcedido')) {
                                        <mat-error>Intervalo máx. de {{ limiteMaxDias }} dias</mat-error>
                                        }
                                    </mat-form-field>
                                    <div class="periodo-intervalo-actions">
                                        <button type="button" mat-button class="btn-secondary"
                                            (click)="cancelarPeriodoIntervalo(periodoMenuTrigger)">Cancelar</button>
                                        <button type="button" mat-flat-button class="btn-primary"
                                            (click)="aplicarPeriodo(periodoMenuTrigger)">Aplicar</button>
                                    </div>
                                </div>
                                }
                            </div>
                        </div>
                    </mat-menu>
                </div>

            </div>

            <!-- Coluna do totalizador -->
            @if (!isLoading && _dataSource.data.length > 0) {
            <div class="total-col">
                <div class="total-col-inner">
                    <mat-icon class="material-icons-outlined icon-total-conciliado">check_circle</mat-icon>
                    <span class="total-col-label">Conciliado no período:</span>
                    <span class="total-col-valor">{{ totalConciliado | abnt:'preco' }}</span>
                </div>
            </div>
            }

        </div>

        @if (!isLoading && _dataSource.data.length > 0) {

        <!-- Tabela Desktop -->
        <table mat-table class="desktop-view" [dataSource]="_flatDataSource" matSort>

            <!-- Checkbox & Indent -->
            <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef class="w-checkbox">
                    <mat-checkbox (change)="$event ? toggleAllRows() : null"
                        [checked]="selection.hasValue() && isAllSelected()" [aria-label]="checkboxLabel()">
                    </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let row" class="w-checkbox">
                    <div class="d-flex align-items-center gap-2">
                        @if (row.isChild) {
                        <mat-icon class="child-indent-icon"
                            style="margin-left: 28px;">subdirectory_arrow_right</mat-icon>
                        } @else {
                        <mat-checkbox (click)="$event.stopPropagation()"
                            (change)="$event ? selection.toggle(row.data) : null"
                            [checked]="selection.isSelected(row.data)" [aria-label]="checkboxLabel(row.data)">
                        </mat-checkbox>
                        }
                    </div>
                </td>
            </ng-container>

            <!-- Data -->
            <ng-container matColumnDef="data">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Data</th>
                <td mat-cell *matCellDef="let row">
                    @if (row.isChild) {
                    {{ row.childData!.dataReferencia | date:'dd/MM/yyyy' }}
                    } @else {
                    {{ row.data.dataTransacao | date:'dd/MM/yyyy' }}
                    }
                </td>
            </ng-container>

            <!-- Descrição -->
            <ng-container matColumnDef="descricao">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Descrição</th>
                <td mat-cell *matCellDef="let row">
                    @if (row.isChild) {
                    <span class="child-descricao html-descricao-container"
                        [innerHTML]="row.childData!.descricao"></span>
                    } @else {
                    <span class="parent-memo">{{ row.data.memo || '(sem descrição)' }}</span>
                    @if (row.data.movimentacoes.length > 0) {
                    <span class="badge-movimentacoes">
                        {{ row.data.movimentacoes.length }} {{ row.data.movimentacoes.length === 1 ? 'movimentação' :
                        'movimentações' }}
                        <mat-icon class="icon-expand">{{ expandedElement === row.data ? 'expand_less' : 'expand_more'
                            }}</mat-icon>
                    </span>
                    }
                    }
                </td>
            </ng-container>

            <!-- Tipo -->
            <ng-container matColumnDef="tipo">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Tipo</th>
                <td mat-cell *matCellDef="let row">
                    @if (row.isChild) {
                    <span class="status-badge {{ classeTipoMatch(row.childData!.tipoMatch) }}">
                        {{ labelTipoMatch(row.childData!.tipoMatch) }}
                    </span>
                    }
                </td>
            </ng-container>

            <!-- Valor -->
            <ng-container matColumnDef="valor">
                <th mat-header-cell *matHeaderCellDef class="text-right" mat-sort-header>Valor</th>
                <td mat-cell *matCellDef="let row" class="text-right">
                    @if (row.isChild) {
                    <span class="valor-child">{{ row.childData!.valorConciliado | abnt:'preco' }}</span>
                    } @else {
                    <span [class.valor-entrada]="row.data.idNaturezaMovimentacao === naturezaEnum.Entrada"
                        [class.valor-saida]="row.data.idNaturezaMovimentacao === naturezaEnum.Saida">
                        {{ row.data.idNaturezaMovimentacao === naturezaEnum.Entrada ? '+' : '-' }}
                        {{ row.data.valor | abnt:'preco' }}
                    </span>
                    }
                </td>
            </ng-container>

            <!-- Ações -->
            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef class="text-center">Ações</th>
                <td mat-cell *matCellDef="let row" class="text-center">
                    @if (!row.isChild) {
                    <button mat-icon-button [matMenuTriggerFor]="menuRow" aria-label="Ações"
                        (click)="$event.stopPropagation()">
                        <span class="material-symbols-outlined">more_horiz</span>
                    </button>
                    <mat-menu #menuRow="matMenu">
                        <button mat-menu-item (click)="abrirDesconciliar(row)">
                            <mat-icon class="material-symbols-outlined">link_off</mat-icon>
                            <span>Desconciliar</span>
                        </button>
                    </mat-menu>
                    }
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" [class.child-row]="row.isChild"
                [class.parent-expanded-row]="!row.isChild && expandedElement === row.data"
                [style.cursor]="!row.isChild && row.data.movimentacoes.length > 0 ? 'pointer' : 'default'"
                (click)="toggleRow(row)">
            </tr>
        </table>

        <!-- Mobile View -->
        <div class="mobile-view">
            @for (item of _dataSource.data; track item.idExtratoBancario) {
            <div class="card-mobile mb-3" [class.selected-card]="selection.isSelected(item)">
                <div class="card-header-mobile d-flex justify-content-between align-items-start">
                    <div class="d-flex align-items-start gap-2 overflow-hidden w-100">
                        <mat-checkbox (click)="$event.stopPropagation()"
                            (change)="$event ? selection.toggle(item) : null" [checked]="selection.isSelected(item)"
                            color="primary" class="mt-1">
                        </mat-checkbox>
                        <div class="d-flex flex-column gap-1 overflow-hidden w-100 mt-1 pe-2">
                            <span class="text-bold ellipsis-title" [title]="item.memo">{{ item.memo || '(sem descrição)'
                                }}</span>
                        </div>
                    </div>
                    <button mat-icon-button [matMenuTriggerFor]="menuMobile" (click)="$event.stopPropagation()">
                        <span class="material-symbols-outlined">more_horiz</span>
                    </button>
                    <mat-menu #menuMobile="matMenu">
                        <button mat-menu-item (click)="abrirDesconciliar({ data: item, isChild: false })">
                            <mat-icon class="material-symbols-outlined">link_off</mat-icon>
                            <span>Desconciliar</span>
                        </button>
                    </mat-menu>
                </div>

                <div class="card-body-mobile p-3">
                    <div class="row">
                        <div class="col-6 mb-2">
                            <small class="d-block">Data Transação</small>
                            <span class="text-bold">{{ item.dataTransacao | date:'dd/MM/yyyy' }}</span>
                        </div>
                        <div class="col-6 mb-2">
                            <small class="d-block">Valor</small>
                            <span [class.valor-entrada]="item.idNaturezaMovimentacao === naturezaEnum.Entrada"
                                [class.valor-saida]="item.idNaturezaMovimentacao === naturezaEnum.Saida"
                                class="text-bold whitespace-nowrap">
                                {{ item.idNaturezaMovimentacao === naturezaEnum.Entrada ? '+' : '-' }}
                                {{ item.valor | abnt:'preco' }}
                            </span>
                        </div>
                    </div>

                    @if (item.movimentacoes.length > 0) {
                    <div class="mt-3">
                        <button mat-button class="w-100 text-center btn-variacoes-mobile mt-1 mb-2"
                            (click)="expandedElement = expandedElement === item ? null : item; $event.stopPropagation()">
                            <mat-icon>{{expandedElement === item ? 'expand_less' : 'expand_more'}}</mat-icon>
                            {{ item.movimentacoes.length }} {{ item.movimentacoes.length === 1 ? 'Movimentação' :
                            'Movimentações' }}
                        </button>

                        @if (expandedElement === item) {
                        <div class="card-movimentacoes-mobile mt-3 pt-2">
                            @for (mov of item.movimentacoes; track mov.idMovimentacao) {
                            <div class="variation-item pb-2 mb-3">
                                <div class="d-flex justify-content-between align-items-center">
                                    <div class="d-flex align-items-center gap-2 overflow-hidden w-100">
                                        <mat-icon class="child-indent-icon flex-shrink-0"
                                            style="font-size: 16px; width: 16px; height: 16px;">subdirectory_arrow_right</mat-icon>
                                        <span
                                            class="mov-descricao html-descricao-container ellipsis-single-line w-100 pe-2"
                                            [innerHTML]="mov.descricao"></span>
                                    </div>
                                    <span class="valor-child text-bold whitespace-nowrap flex-shrink-0"
                                        style="margin-left:8px;">{{ mov.valorConciliado | abnt:'preco' }}</span>
                                </div>
                                <div class="d-flex align-items-center gap-2 mt-2" style="padding-left: 24px;">
                                    <span class="status-badge {{ classeTipoMatch(mov.tipoMatch) }}">{{
                                        labelTipoMatch(mov.tipoMatch) }}</span>
                                    <small>{{ mov.dataReferencia | date:'dd/MM/yyyy' }}</small>
                                </div>
                            </div>
                            }
                        </div>
                        }
                    </div>
                    }
                </div>
            </div>
            }
        </div>

        <!-- Ver Mais -->

        <div class="col-12 text-center mt-3">
            <button mat-button [disabled]="isLoading || !_temMais" (click)="proximaPagina()">
                @if (isLoading) {
                <mat-spinner [diameter]="20"></mat-spinner>
                } @else {
                <span class="material-symbols-outlined">expand_more</span>
                Ver Mais
                }
            </button>
        </div>


        } @else if (isLoading) {
        <app-loading-box-default-list></app-loading-box-default-list>
        } @else {
        <app-empty-list title="Nenhum lançamento conciliado."
            subTitle="Os lançamentos conciliados no período selecionado aparecerão aqui.">
        </app-empty-list>
        }

    </div>
</div>